import { createContext } from 'react';

export type AnimatingCircleContextValue = {
  targetId: string;
  setTargetId: (id: string) => void;
};
export const AnimatingCircleContext =
  createContext<AnimatingCircleContextValue>({} as any);
